import { useEffect, useState } from 'react'

/**
 * React hook wrapping `window.matchMedia`.
 * Returns `true` when the media query matches; updates live on viewport changes.
 *
 * Usage: `const isMobile = useMatchMedia('(max-width: 767px)')`
 */
export const useMatchMedia = (query: string): boolean => {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

    useEffect(() => {
        const mql = window.matchMedia(query)
        const handler = (e: MediaQueryListEvent) => setMatches(e.matches)

        // Sync in case state drifted between render and effect
        setMatches(mql.matches)

        mql.addEventListener('change', handler)
        return () => mql.removeEventListener('change', handler)
    }, [query])

    return matches
}
